// extracted by mini-css-extract-plugin
export var cardIcon = "_4j-4";
export var checkboxCard = "_4j-0";
export var checkboxCardSelected = "_4j-1";
export var disabled = "_4j-2";
export var outerBorder = "_4j-3";
export var spacerMedium = "_4j-7";
export var spacerSmall = "_4j-6";
export var spacerXsmall = "_4j-5";